var _rect, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgBoxAprLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 214,
    height: 67,
    viewBox: "0 0 214 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_427_211)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 213.667,
    height: 67,
    fill: "#F3F4F8"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.04
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.11109 38.623H-1.88959C-2.95564 38.623 -3.92566 39.2391 -4.37888 40.204L-21.3802 76.4004C-22.2369 78.2243 -20.906 80.3198 -18.8909 80.3198H-7.70746C-6.63729 80.3198 -5.66429 79.699 -5.21334 78.7285L11.6052 42.5321C12.4522 40.7092 11.1212 38.623 9.11109 38.623Z",
    fill: "#5E5E6B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0272 38.623H42.9199C44.9277 38.623 46.2588 40.7049 45.4162 42.5274L38.272 57.9806C37.8221 58.9537 36.8477 59.5767 35.7757 59.5767H20.5816L28.6293 76.3818C29.5036 78.2073 28.1729 80.3198 26.1489 80.3198H15.1688C14.1025 80.3198 13.1323 79.7034 12.6792 78.7382L5.52482 63.4954C4.66878 61.6716 5.99969 59.5767 8.01444 59.5767H20.5816L29.5308 40.2192C29.9807 39.246 30.9551 38.623 32.0272 38.623Z",
    fill: "#5E5E6B"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_427_211"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 213.667,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgBoxAprLight);
export default __webpack_public_path__ + "static/media/BgBoxAprLight.d677e96950cd020d2177b080e8c7fddd.svg";
export { ForwardRef as ReactComponent };